import { AppColors } from "@/styles/colors";
import { Checkbox, Field } from "@chakra-ui/react";
import { Control, Controller } from "react-hook-form";

interface Props {
  control: Control<any>;
  invalid?: boolean;
  name: string;
  errorMessage?: string;
  label?: string;
  disabled?: boolean;
}

export const CustomCheckbox = ({
  control,
  invalid,
  label,
  name,
  errorMessage,
  disabled,
}: Props) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Field.Root invalid={invalid} disabled={disabled || field.disabled}>
          <Checkbox.Root
            checked={field.value}
            onCheckedChange={({ checked }) => field.onChange(checked)}
            disabled={disabled || field.disabled}
          >
            <Checkbox.HiddenInput />
            <Checkbox.Control borderColor={AppColors.GRAY_BORDER_1} />
            <Checkbox.Label>{label}</Checkbox.Label>
          </Checkbox.Root>
          <Field.ErrorText>{errorMessage}</Field.ErrorText>
        </Field.Root>
      )}
    />
  );
};
